import { render } from "./MyAccountView.vue?vue&type=template&id=e01818e8"
import script from "./MyAccountView.vue?vue&type=script&lang=js"
export * from "./MyAccountView.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__